import { MapStyleConfiguration } from '@services/map/abstract-map.service';
import { NDWMapStyle } from '@ndwnu/map';
import { LayerSpecification, StyleSpecification, SymbolLayerSpecification } from 'maplibre-gl';

const NDW_HECTOMETRE_SIGNS_LAYER_ID = 'nwb-hectometre-signs-rel';

/**
 * The hectometre shields from the NDW map style, as a standalone overlay that works on every
 * background. The NDW style ships them hidden with `icon-padding: 20`, which makes the shields on
 * opposite sides of a road knock each other out; 2 is the MapLibre default. The NDW style loads its
 * sprite under the `NDW:` id, while our map loads the same sprite without an id, so that prefix is
 * stripped from the icon names. If a future @ndwnu/map drops the layer, the overlay stays empty
 * instead of breaking every map page at import time.
 */
function hectometreSignsStyle(): StyleSpecification {
  const ndwLayer = NDWMapStyle.layers.find((layer) => layer.id === NDW_HECTOMETRE_SIGNS_LAYER_ID);
  if (ndwLayer?.type !== 'symbol') {
    console.warn(`Layer '${NDW_HECTOMETRE_SIGNS_LAYER_ID}' not found in NDWMapStyle`);
    return { version: 8, sources: {}, layers: [] };
  }
  const layer = JSON.parse(
    JSON.stringify(ndwLayer).replaceAll('"NDW:', '"'),
  ) as SymbolLayerSpecification;

  return {
    version: 8,
    sources: { [layer.source]: NDWMapStyle.sources[layer.source] },
    layers: [
      {
        ...layer,
        layout: { ...layer.layout, visibility: 'visible', 'icon-padding': 2 },
      } as LayerSpecification,
    ],
  };
}

export const HECTOMETRE_STYLE = {
  id: 'hectometreSignsId',
  symbolsId: 'hectometreSignsId',
  style: hectometreSignsStyle(),
} as MapStyleConfiguration;

export const FCD_VECTOR_STYLE = {
  id: 'fcd',
  symbolsId: 'fcdVectorId',
  style: '/assets/map-style/fcd.json',
} as MapStyleConfiguration;

export const CLOSURES_VECTOR_STYLE = {
  id: 'closures',
  symbolsId: 'closuresVectorId',
  style: '/assets/map-style/closures.json',
} as MapStyleConfiguration;

export const RAYON_VECTOR_STYLE = {
  id: 'rayon',
  symbolsId: 'rayonVectorId',
  style: '/assets/map-style/rayon.json',
} as MapStyleConfiguration;

export const IM_WEGEN_VECTOR_STYLE = {
  id: 'im_wegen',
  symbolsId: 'imWegenVectorId',
  style: '/assets/map-style/im_wegen.json',
} as MapStyleConfiguration;
